import {createAction} from '@reduxjs/toolkit'

export const setActiveElement = createAction<string>('SET_ACTIVE_ELEMENT')
